<div class="modal fade" tabindex="-1" role="dialog" #issuesDialog>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="title">
          <h4 class="modal-title">Проблемы на адресе "{{ destination?.destination.addr }}"</h4>
        </div>
      </div>
      <div class="modal-body">
        <delivery-issues [issues]="issues" [loading]="loading" [productVisible]="false"></delivery-issues>
      </div>
      <div class="modal-footer" *ngIf="enabledCreateForDestination">
        <button type="button" class="save-btn pull-right" title="Создание проблемы" (click)="onCreate()">Создать</button>
      </div>
    </div>
  </div>
</div>
